import { BooksyAndSearchComponent } from './booksy-and-search/booksy-and-search.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticlesBoxComponent } from './articles-box/articles-box.component';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { ArticleDetailsComponent } from './article-details/article-details.component';
import { LoadingComponent } from './loading/loading.component';
import { NgxMaskModule } from 'ngx-mask';
import { GalleryComponent } from './gallery/gallery.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { ArticleBoxComponent } from './article-box/article-box.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { Nl2brPipe } from '../nl2br.pipe';
import { QuillModule } from 'ngx-quill';
import { FooterComponent } from './footer/footer.component';
import { NewsleterComponent } from './newsleter/newsleter.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ReactiveFormsModule } from '@angular/forms';
import { LazyLoadImageModule, LAZYLOAD_IMAGE_HOOKS } from 'ng-lazyload-image';
import { Page404Component } from './page404/page404.component';
import { ProductBoxComponent } from './product-box/product-box.component';
import { LazyLoadImageHooks } from '../app.module';
import { SafeHtmlPipe } from './safeHtml.pipe';
import { GalleryModule } from '@ngx-gallery/core';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { LatinisePipe, SlugifyPipe } from 'ngx-pipes';
import { SafeHtmlSecurityPipe } from './safeHtmlSecurity.pipe';

@NgModule({
  declarations: [
    Nl2brPipe,
    ArticlesBoxComponent,
    HeaderComponent,
    ArticleDetailsComponent,
    LoadingComponent,
    GalleryComponent,
    PageHeaderComponent,
    ArticleBoxComponent,
    BreadcrumbComponent,
    FooterComponent,
    NewsleterComponent,
    BooksyAndSearchComponent,
    Page404Component,
    ProductBoxComponent,
    SafeHtmlPipe,
    SafeHtmlSecurityPipe,
  ],
  imports: [
    CommonModule,
    GalleryModule,
    QuillModule,
    ReactiveFormsModule,
    NgxSmartModalModule,
    LazyLoadImageModule,
    LightboxModule,
    NgxMaskModule.forRoot(),
    RouterModule,
  ],
  exports: [
    Nl2brPipe,
    ArticlesBoxComponent,
    HeaderComponent,
    ArticleDetailsComponent,
    LoadingComponent,
    GalleryComponent,
    PageHeaderComponent,
    ArticleBoxComponent,
    BreadcrumbComponent,
    FooterComponent,
    Page404Component,
    BooksyAndSearchComponent,
    ProductBoxComponent,
    SafeHtmlPipe,
    SafeHtmlSecurityPipe,
  ],
  providers: [
    { provide: LAZYLOAD_IMAGE_HOOKS, useClass: LazyLoadImageHooks },
    LatinisePipe,
    SlugifyPipe,
  ],
})
export class SharedModule {}
